import { render, staticRenderFns } from "./PrivateNoteVo.vue?vue&type=template&id=3def01e6&scoped=true&"
import script from "./PrivateNoteVo.vue?vue&type=script&lang=js&"
export * from "./PrivateNoteVo.vue?vue&type=script&lang=js&"
import style0 from "./PrivateNoteVo.vue?vue&type=style&index=0&id=3def01e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def01e6",
  null
  
)

export default component.exports